export function invertRecordOfArrays(record) {
  const invertedRecord = {};
  Object.entries(record).forEach(([key, values]) => {
    values.forEach(value => {
      if (!invertedRecord[value]) {
        invertedRecord[value] = [];
      }
      invertedRecord[value].push(key);
    });
  });
  return invertedRecord;
}